module.exports = __webpack_public_path__ + "img/Spinner3.53cb0285.gif";